import { Card, CardContent, CardHeader } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TestInfoCard from '../../../../components/TestInfoCard';
import palette from '../../../../theme/palette';
import MarkingSchema from '../../../../components/MarkingSchema';
import NameAndChangeToScreenCard from '../../../../components/NameAndChangeToScreenCard';
import EyeIcon from '../../../../svg/EyeIcon';
import '../../../../css/upcomingTest.css';
import PageIcon from '../../../../svg/PageIcon';
import Header from '../../../../components/Header';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import MySolution from './Student.MySolution';

export default function PreviousTestDetails({ testDetails, onBack }) {
  const {
    name,
    type,
    totalMark,
    createdAt,
    startDate,
    startTime,
    correctMark,
    incorrectMark,
    duration
  } = testDetails;
  const [selectedScreen, setSelScreen] = useState(null);
  return (
    <div style={{ marginTop: 20 }}>
      {/* eslint-disable-next-line */}
      {selectedScreen === null ? (
        <>
          <Header title={name} onBack={onBack} />
          {type === 'upload' && testDetails?.typeURL && (
            <Card style={{ marginTop: 15 }}>
              <CardHeader title="Download the test paper" />
              <CardContent>
                <DownloadFileContainer title={testDetails?.typeURL} isDownload />
              </CardContent>
            </Card>
          )}
          <TestInfoCard
            createdOn={moment(createdAt).format('DD MMM, LT')}
            startTime={`${moment(startDate).format('DD MMM,')} ${moment(startTime).format('LT')}`}
            endTime={`${moment(startDate).format('DD MMM,')} ${moment(startTime)
              .add(duration, 'minutes')
              .format('LT')}`}
            duration={`${duration} minutes`}
            questions={
              // eslint-disable-next-line
              type === 'type'
                ? testDetails.questions.length
                : testDetails?.totalQuestions
                ? testDetails.totalQuestions
                : null
            }
            marks={totalMark}
          />
          <MarkingSchema
            correctAns={correctMark}
            incorrectAns={incorrectMark < 0 ? `-${incorrectMark}` : incorrectMark}
          />
          {testDetails?.isSolutionUploaded && (
            <Card style={{ marginTop: 15 }}>
              <CardHeader title="Download solution" />
              <CardContent>
                <DownloadFileContainer
                  title={testDetails?.solutionURL}
                  fileLink={testDetails?.solutionURL}
                  isDownload
                />
              </CardContent>
            </Card>
          )}
          {(testDetails?.submissionId || type === 'UPLOAD') && (
            <Card style={{ marginTop: 25 }}>
              <CardContent>
                {testDetails?.submissionId && (
                  <NameAndChangeToScreenCard
                    title="My Solution"
                    isStudent
                    icon={<PageIcon color={palette.secondary.main} />}
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/dashboard/test/${testDetails?.id}/result/${testDetails?.submissionId}`
                      )
                    }
                  />
                )}
                {type === 'UPLOAD' && (
                  <NameAndChangeToScreenCard
                    title="View Teacher Solution"
                    icon={<EyeIcon color={palette.secondary.main} />}
                    onClick={() => setSelScreen('upload')}
                  />
                )}
              </CardContent>
            </Card>
          )}
        </>
      ) : (
        selectedScreen === 'solution' && (
          <MySolution onBack={() => setSelScreen(null)} testDetails={testDetails} />
        )
      )}
    </div>
  );
}

PreviousTestDetails.propTypes = {
  testDetails: PropTypes.object,
  onBack: PropTypes.func
};
